import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await register(email, password, name);
    setBusy(false);
    if (r.ok) navigate("/");
    else toast.error(r.error || "Register failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 p-8 rounded-lg space-y-5" data-testid="register-form">
        <div>
          <div className="label-eyebrow">{t("register")}</div>
          <div className="font-heading text-2xl font-semibold text-slate-900 mt-1">KiraTakip</div>
        </div>
        <div>
          <label className="label-eyebrow">{t("name")}</label>
          <Input data-testid="reg-name" value={name} onChange={(e) => setName(e.target.value)} className="mt-1.5" />
        </div>
        <div>
          <label className="label-eyebrow">{t("email")}</label>
          <Input data-testid="reg-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
        </div>
        <div>
          <label className="label-eyebrow">{t("password")}</label>
          <Input data-testid="reg-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
        </div>
        <Button data-testid="reg-submit" type="submit" disabled={busy} className="w-full h-11 rounded-md bg-slate-900 hover:bg-slate-800">
          {busy ? "…" : t("register")}
        </Button>
        <div className="text-sm text-slate-600">
          {t("have_account")}{" "}
          <Link to="/login" data-testid="go-login" className="font-semibold text-slate-900 underline">{t("login")}</Link>
        </div>
      </form>
    </div>
  );
}
